//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            answers: [
                {
                    label: this.$lang.get('w4d1.game2.best'),
                    correct: true,
                    clicked: false
                },
                {
                    label: this.$lang.get('w4d1.game2.team'),
                    correct: true,
                    clicked: false
                },
                {
                    label: this.$lang.get('w4d1.game2.luck'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w4d1.game2.duck'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w4d1.game2.accomplish'),
                    correct: true,
                    clicked: false
                },
                {
                    label: this.$lang.get('w4d1.game2.never'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w4d1.game2.other'),
                    correct: false,
                    clicked: false
                },
                {
                    label: this.$lang.get('w4d1.game2.goal'),
                    correct: true,
                    clicked: false
                },
                {
                    label: this.$lang.get('w4d1.game2.better'),
                    correct: true,
                    clicked: false
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.answers.filter(answer => answer.correct && answer.clicked).length;
            let numTotalCorrect = this.answers.filter(answer => answer.correct).length;
            let numWrong = this.answers.filter(answer => !answer.correct && answer.clicked).length;

            return this.$game.getMultipleChoiceResult(numCorrect, numTotalCorrect, numWrong);
        },
        runnersScale () {
            let numCorrect = this.answers.filter(answer => answer.correct && answer.clicked).length;
            let numTotalCorrect = this.answers.filter(answer => answer.correct).length;
            let numWrong = this.answers.filter(answer => !answer.correct && answer.clicked).length;
            let numTotalWrong = this.answers.filter(answer => !answer.correct).length;

            return 0.3 + numCorrect / numTotalCorrect * 0.7 - numWrong / numTotalWrong * 0.2;
        },
        avatar () {
            return this.$store.getters.avatar;
        }
    }
};
